export default "__VITE_ASSET__CAKWFaqX__"